import React, {useState, useEffect} from 'react';
import Header from '../../components/Header/index';
import ToolBarMenu from '../../components/ToolBarMenu/index';
import PageHeader from '../../components/PageHeader/index';
import Footer from '../../components/Footer';
import TabPanel, {Item}from 'devextreme-react/tab-panel';
import PageWrapper from '../../components/PageWrapper/index';
import {useSearchAll} from './../../queries/searchAll';
import SearchAllDetail from "./SearchAllDetail";
import {useSearchPageHeader} from "./../../queries/searchPageHeader";
import InfinitProgressBar from '../../components/InfiniteProgressBar';



const SearchPage = () => {
    const [searchAllState, setSearchAllState] = useState({
        searchText: "",
        blogs: [],
        news: [],
        aboutUs: [],
        products: []
    });

    function groupBy(list){  
       return list.reduce((r, a) => {                
            r[a.content_ContentItem_DisplayText] = r[a.content_ContentItem_DisplayText ] || [];
            r[a.content_ContentItem_DisplayText].push(a); 
        return r;
    }, Object.create(list));
    }
    
    
    const searchTerm = new URLSearchParams(window.location.search).get("search");
    const searchResult = useSearchAll(`{ fulltext: '${searchTerm}'}`);
    const searchHeader = useSearchPageHeader();



    useEffect(() => {
        
        setSearchAllState({
            products: (searchResult.data ? groupBy(searchResult.data.searchAll.filter(x => x.content_ContentItem_ContentType === "Product")) : []),
            blogs: (searchResult.data ? groupBy(searchResult.data.searchAll.filter(x => x.content_ContentItem_ContentType === "Blog")) : []),
            news: (searchResult.data ? groupBy(searchResult.data.searchAll.filter(x => x.content_ContentItem_ContentType === "News")) : []),
            aboutUs: (searchResult.data ? groupBy(searchResult.data.searchAll.filter(x => x.content_ContentItem_ContentType === "AboutUs")) : []), 
            searchText: `${searchTerm}` })
        }, [searchResult.loading]); 
    if(searchResult.loading) return <InfinitProgressBar/>
    if(searchResult.error) return <div>error!</div>
    if(searchHeader.loading) return <InfinitProgressBar/>
    if(searchHeader.error) return <div>error!</div>
    
    return (  
        <>
            {/* <ToolBarMenu/> */}
            <Header/>
            <PageHeader
                bgImg={searchHeader.data.searchPageHeader[0].searchPageHeader.urls[0]}
                title='نتایج جستجو'
                content=''
            />
            <PageWrapper classes={'product-page-content-area sp-y'}>

                <SearchAllDetail result={searchAllState}/>

            </PageWrapper>
            <br/>
            <br/>
            <br/>
            <br/>

            <Footer/>
        
        </>
    );
}
 
export default SearchPage;